import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ark-email-icon',
  templateUrl: './email-icon.component.html',
  styleUrls: ['./email-icon.component.scss']
})
export class EmailIconComponent implements OnInit {

  @Output() onClick = new EventEmitter<any>();

  constructor() { }

  onClickButton(event) {
    this.onClick.emit(event);
  }

  ngOnInit() {
  }

}
